import LegacyNotice from './Components/Layout/Marketing/LegacyNotice';
import { isMarketingPage } from './utils/marketingTrackers';
import apiClient from './utils/axios';
// // App.jsx
// 
// import React, { useEffect, useState, useContext, useMemo } from 'react';
// import {
//     AdvisorsPage,
//     DemoPage,
//     NewsletterSection,
//     ProblemOutcomesPage,
//     ProductFeaturesPage,
//     ProductHowItWorksPage,
//     ProductOverviewPage,
//     SecurityPage,
//     SolutionsDeliveryPage,
//     SolutionsFinancePage,
//     SolutionsOperationsPage,
//     IntegrationsPage,
// } from './Components/Layout/Marketing';
// 
// import { DndContext } from '@dnd-kit/core';
// import Cookies from 'js-cookie';
// import { ProjectProvider, useProjects } from './ProjectContext.jsx';
// import { AuthProvider } from './Auth/AuthContext';
// import NavBar from './Components/Layout/NavBar.jsx';
// import ProjectsContainer from './Components/Projects/ProjectsContainer.jsx';
// import ExpensesContainer from './Components/Expenses/ExpensesContainer.jsx';
// import Footer from './Components/Layout/FooterPro.jsx';
// import AboutUs from './Components/Layout/AboutUs.jsx';
// import HomePage from './Components/Layout/HomePage.jsx';
// import ProjectForm from './Components/Forms/ProjectForm.jsx';
// import ExpenseForm from './Components/Forms/ExpenseForm.jsx';
// import SignUpForm from './Components/UserManagement/UserSignUpForm.jsx';
// import LoginForm from './Components/UserManagement/LoginForm.jsx';
// import AccountManagement from './Components/UserManagement/AccountManagement.jsx';
// import AccountRecovery from './Components/UserManagement/AccountRecovery.jsx';
// import ProtectedRoute from './Components/Layout/ProtectedRoute.jsx';
// import { CssBaseline, ThemeProvider, Dialog } from '@mui/material'; 
// import GlobalStyles from '@mui/material/GlobalStyles';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Dashboard from './Pages/Dashboard.jsx';
// import TeamDashboard from './Pages/TeamDashboard.jsx';
// import SelectPlan from './Pages/SelectPlan.jsx';
// // import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
// import { Route, Routes, useNavigate, useLocation, Navigate } from 'react-router-dom';
// 
// 
// import ProjectDetail from './Components/Projects/ProjectDetail';
// 
// import VoiceCommand from './Components/FinnixAI/VoiceCommand';
// 
// // From context
// import { SettingsContext } from './context/SettingsContext';
// import { getTheme } from './theme';
// 
// // Admin and specific pages
// import ProtectedAdminRoute from './Components/Layout/ProtectedAdminRoute';
// import WaitlistLandingPage from './Pages/WaitlistLandingPage';
// import TeamManagement from './Pages/TeamManagement';
// import PitchPage from './MicroSite/PitchPage';
// import SalesBrief from './MicroSite/SalesBrief';
// import AccountVerification from './Components/UserManagement/AccountVerification';
// import PasswordReset from './Components/UserManagement/PasswordReset';
// import LogTimePage from './Pages/LogTimePage';
// import AdvisoryForm from './Pages/AdvisoryForm';
// import AdvisoryAdminPage from './Pages/AdvisoryAdminPage';
// import AdminDashboard from './Components/AdminDashboard.jsx';
// import ConfirmEmail from './Auth/ConfirmEmail';
// import { UpgradePromptToast } from './Components/Toasts';
// 
// import { resolvePlan, hasFeature } from './utils/planUtils';
// 
// import { notifyInfo } from './utils/toastUtils';
// 
// // New Offshoot Company "Melucra"
// import MelucraLanding from './Melucra/components/MelucraLanding';
// import MelucraInvestorBrief from './Melucra/pages/MelucraInvestorBrief';
// import MelucraDashboardPage from './Melucra/pages/MelucraDashboardPage';
// 
// 
// import OnboardingWizard from './Pages/OnboardingWizard';
// 
// // Utilities for analytics
// import { useTrackUser } from './utils/useTrackUser';
// import { startSessionTimer, stopSessionTimer } from './utils/analyticsTimers';
// import posthog from 'posthog-js';
// import ContactsPage from './Pages/ContactsPage';
// 
// // NEW HIERARCHY PAGES & FORMS
// import ProgramOverview from './Pages/ProgramOverview.jsx';
// import PortfolioOverview from './Pages/PortfolioOverview.jsx';
// import HierarchyForm from './Components/Forms/HierarchyForm.jsx';
// 
// import UseCasePage from 'Pages/use-cases/UseCasePage';
// 
// // Cookie Management
// import CookieConsentManager from './Components/CookieConsentManager';
// import CookiePolicy from './Pages/CookiePolicy';
// import PrivacyPage from './Pages/PrivacyPage';
// import InviteForm from './Components/Admin/InviteForm';
// 
// import RedirectToSignup from './Components/RedirectToSignup';
// 
// import AdminRoute from './Components/Layout/AdminRoute';
// 
// import InternalRoute from './Components/Layout/InternalRoute';
// 
// import FeedbackPrompt from './Components/FeedbackPrompt';
// 
// import Lenis from 'lenis';
// 
// 
// export const getCookie = (name) => {
//     const value = `; ${document.cookie}`;
//     const parts = value.split(`; ${name}=`);
//     if (parts.length === 2) return parts.pop().split(';').shift();
// };
// 
// const App = () => {
// 
//     const { themeMode, compactMode } = useContext(SettingsContext);
// 
// 
//     const [isAuthenticated, setIsAuthenticated] = useState(false);
//     const [currentUser, setCurrentUser] = useState(null);
//     useTrackUser(currentUser);
// 
// // Treat melucra.com (prod) OR /melucra path (dev) as Melucra mode
// // const isMelucra =
// //   window.location.host.includes("melucra.com") ||
// // //   window.location.pathname.startsWith("/melucra");
// //   window.location.pathname.startsWith("/investorbrief");
// //   window.location.pathname.startsWith("/meldashboard");
// // 
// //   // 🌟 ADDITION: The dashboard redirect for the main domain
// // const shouldRedirectDashboardToProto = isMelucraDomain && (window.location.pathname === '/dashboard');
// 
// 
// // 🌟  Melucra variables in the component scope
// 
// const isMelucraDomain = window.location.host.includes("melucra.com");
// 
// const isMelucra =
//   isMelucraDomain ||
//   window.location.pathname.startsWith("/melbrief") ||
//   window.location.pathname.startsWith("/meldashboard") ||
//   window.location.pathname.startsWith("/melLanding");
// 
// // 🌟 ADDITION: Specific override for the /dashboard path when on the Melucra domain
// const shouldRedirectDashboardToProto = isMelucraDomain && (window.location.pathname === '/melLanding');
// 
// 
//     // ADDED: State for HierarchyForm modal
//     const [isHierarchyFormModalOpen, setIsHierarchyFormModalOpen] = useState(false);
// 
//     useEffect(() => {
//         startSessionTimer();
//         return () => {
//             stopSessionTimer();
//         };
//     }, []);
// // Smooth scrolling with Lenis
// useEffect(() => {
//   const lenis = new Lenis({
//     duration: 1.2, // adjust speed
//     easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // easing curve
//     smoothWheel: true,
//     smoothTouch: false,
//   });
// 
//   function raf(time) {
//     lenis.raf(time);
//     requestAnimationFrame(raf);
//   }
//   requestAnimationFrame(raf);
// 
//   return () => {
//     lenis.destroy();
//   };
// }, []);
// 
// 
//     const [loading, setLoading] = useState(true);
//     const navigate = useNavigate();
//     const location = useLocation();
// 
//     const [searchQuery, setSearchQuery] = useState('');
//     const [statusFilter, setStatusFilter] = useState('');
//     const [sortOption, setSortOption] = useState('');
// 
//     const showToast = (message, type = 'success') => toast[type](message);
//     useEffect(() => {
//         const checkAuth = async () => {
//             try {
//                 const response = await fetch('/auth/me', {
//                     credentials: 'include',
//                     cache: 'no-store' // Prevents browser caching issues
//                 });
// 
//                 if (!response.ok) {
//                     throw new Error('Not authenticated');
//                 }
// 
//                 const userData = await response.json();
//                 setCurrentUser(userData);
//                 setIsAuthenticated(true);
// 
//             } catch (err) {
//                 // Any error in the try block means the user is not authenticated.
//                 console.error("Auth check failed:", err);
//                 setCurrentUser(null);
//                 setIsAuthenticated(false);
//             } finally {
//                 // This will now always run, whether the auth check succeeds or fails.
//                 setLoading(false);
//             }
//         };
// 
//         checkAuth();
//     }, []);
// 
//     // MODIFIED: useEffect for route change tracking to control modal
//     useEffect(() => {
//         posthog.capture('$pageview');
//         if (location.pathname === '/hierarchy/new') {
//             setIsHierarchyFormModalOpen(true);
//         } else if (isHierarchyFormModalOpen) {
//             // If modal was open but we navigated away, close it
//             setIsHierarchyFormModalOpen(false);
//         }
//     }, [location.pathname, isHierarchyFormModalOpen]);
// 
//     // MODIFIED: Onboarding redirection logic with sessionStorage flag
//     useEffect(() => {
//         // Read the flag from sessionStorage.
//         const clientMarkedDone = sessionStorage.getItem('onboarding_complete') === 'true';
// 
//         // The original conditions are still valid...
//         if (
//             isAuthenticated &&
//             currentUser?.needs_onboarding &&
//             location.pathname !== '/onboarding' &&
//             !clientMarkedDone // ...BUT we add this check.
//         ) {
//             // Only redirect if the user hasn't just finished.
//             navigate('/onboarding', { replace: true });
//         }
//     }, [isAuthenticated, currentUser, location.pathname, navigate]);
// 
//     const handleSignUpSuccess = (user) => {
//         setIsAuthenticated(true);
//         setCurrentUser(user);
// 
//         // Show a welcome toast.
//         toast.success(`Welcome, ${user.name || 'User'}! Let's get you set up.`);
//         navigate('/dashboard');
//     };
// 
//     // This is the corrected, reliable version
//     const handleLoginSuccess = ({ user }) => {
//         setIsAuthenticated(true);
//         setCurrentUser(user);
//         toast.success(`Welcome back, ${user.name || 'User'}!`);
//         navigate('/dashboard');
//     };
// 
//     // THIS IS THE CORRECTED LOGOUT FUNCTION
//     const handleSignOut = () => {
//         fetch("/logout", {
//             method: "DELETE",
//             headers: {
//                 'X-CSRF-TOKEN': getCookie("csrf_access_token")
//             }
//         })
//             .then((res) => {
//                 if (res.ok) {
//                     // --- ADD THIS LINE ---
//                     sessionStorage.removeItem('onboarding_complete');
// 
//                     setCurrentUser(null);
//                     setIsAuthenticated(false);
//                     showToast("You have been signed out successfully.");
//                     navigate("/");
//                 } else {
//                     res.json().then((errorData) => {
//                         showToast(errorData.error || "Error signing out", "error");
//                         if (res.status === 401) navigate("/");
//                     });
//                 }
//             })
//             .catch(() => {
//                 setCurrentUser(null);
//                 setIsAuthenticated(false);
//                 showToast("You have been signed out due to a network error.", "info");
//                 navigate("/");
//             });
//     };
// 
//     // Chatbot integration
//     //     useEffect(() => {
//     //   const handleOnboardingPrompt = (e) => {
//     //     const message = e.detail?.message;
//     //     if (message) notifyInfo(message);
//     //   };
//     // 
//     //   window.addEventListener('onboardingPrompt', handleOnboardingPrompt);
//     //   return () => {
//     //     window.removeEventListener('onboardingPrompt', handleOnboardingPrompt);
//     //   };
//     // }, []);
// 
// 
//     const { updateProjectParent } = useProjects();
// 
//     const handleDragEnd = async (event) => {
//         const { active, over } = event;
// 
//         if (active && over) {
//             const draggedProjectId = active.id;
//             const droppedZoneId = over.id;
// 
//             console.log(`Dragged project ID: ${draggedProjectId}, Dropped onto: ${droppedZoneId}`);
// 
//             let newProgramId = null;
//             let newPortfolioId = null;
// 
//             if (String(droppedZoneId).startsWith('program_')) {
//                 newProgramId = parseInt(String(droppedZoneId).replace('program_', ''));
//                 newPortfolioId = null;
//             } else if (String(droppedZoneId).startsWith('portfolio_')) {
//                 newPortfolioId = parseInt(String(droppedZoneId).replace('portfolio_', ''));
//                 newProgramId = null;
//             } else if (String(droppedZoneId) === 'orphan_zone') {
//                 newProgramId = null;
//                 newPortfolioId = null;
//             } else {
//                 console.warn("Dropped onto an unrecognized zone:", droppedZoneId);
//                 return;
//             }
// 
//             try {
//                 await updateProjectParent(parseInt(draggedProjectId), newProgramId, newPortfolioId);
//                 showToast("Project reassigned successfully!", "success");
//             } catch (error) {
//                 showToast("Failed to reassign project.", "error");
//                 console.error("Drag-and-drop reassign error:", error);
//             }
//         }
//     };
// 
//     const isInviteRoute = location.pathname.startsWith('/accept-invite/');
//     // const plan = currentUser?.organization_plan || currentUser?.organization?.plan || currentUser?.subscription_plan || 'free';
// 
//     // const plan = resolvePlan(currentUser);
//     // const isPaidPlan = hasFeature(currentUser, 'multi_user_dashboards');
//     const plan = useMemo(() => resolvePlan(currentUser), [currentUser]);
//     const isPaidPlan = useMemo(() => hasFeature(currentUser, 'multi_user_dashboards'), [currentUser]);
// 
// 
// 
//     // console.debug('[App.jsx] resolved plan:', plan);
//     useEffect(() => {
//         if (currentUser) {
//             console.debug('[App.jsx] resolved plan:', plan);
//         }
//     }, [currentUser, plan]);
// 
//     const canManageTeam = isAuthenticated && currentUser && (
//         currentUser.role === 'SUPER_ADMIN' ||
//         (currentUser.role === 'ADMIN' && isPaidPlan)
//     );
// 
// 
// // // MELUCRA MODE RENDERING BLOCK
// // if (isMelucra) {
// //   return (
// //     <ThemeProvider theme={getTheme(themeMode, compactMode)}>
// //       <CssBaseline />
// //       {/* Melucra App Wrapper */}
// // //       <div className="melucra-wrapper">
// //         <Routes>
// //           
// //           {/* Prototype Dashboard */}
// //           <Route path="/meldashboard" element={<MelucraDashboardPage />} /> 
// //           
// //           {/* Investor Brief */}
// //           <Route path="/melbrief" element={<MelucraInvestorBrief />} />
// // 
// //           {/* Canonical Landing Page */}
// //           <Route path="/mellanding" element={<MelucraLanding />} />
// //           
// //           {/* Domain Override: /dashboard redirect */}
// //           {shouldRedirectDashboardToProto && (
// //               <Route path="/dashboard" element={<MelucraDashboardPage />} />
// //           )}
// // 
// //           {/* Legacy /melucra URL redirect */}
// //           <Route path="/melucra" element={<Navigate to="/melLanding" replace />} /> 
// // 
// //           {/* Root Route Logic (/) */}
// //           <Route path="/" element={
// //             isMelucraDomain 
// //               ? <Navigate to="/meldashboard" replace /> // Prod Root -> Prototype
// //               : <Navigate to="/melLanding" replace /> // Dev Root -> Landing
// //           } />
// // 
// //           {/* Final Fallback */}
// //           <Route path="*" element={<Navigate to="/melLanding" replace />} />
// //         </Routes>
// //       </div>
// //     </ThemeProvider>
// //   );
// // }
// 
// // 🌟 START MELUCRA MODE RENDERING BLOCK 🌟
// 
// // MELUCRA MODE RENDERING BLOCK
// if (isMelucra) {
//   return (
//     <ThemeProvider theme={getTheme(themeMode, compactMode)}>
//       <CssBaseline />
//       {/* Correctly defined Melucra App Wrapper */}
//       <div className="melucra-wrapper">
//         <Routes>
//           
//           {/* Prototype Dashboard */}
//           <Route path="/meldashboard" element={<MelucraDashboardPage />} /> 
//           
//           {/* Investor Brief */}
//           <Route path="/melbrief" element={<MelucraInvestorBrief />} />
// 
//           {/* Canonical Landing Page */}
//           <Route path="/mellanding" element={<MelucraLanding />} />
//           
//           {/* Domain Override: /dashboard redirect */}
//           {shouldRedirectDashboardToProto && (
//               <Route path="/dashboard" element={<MelucraDashboardPage />} />
//           )}
// 
//           {/* Legacy /melucra URL redirect */}
//           <Route path="/melucra" element={<Navigate to="/mellanding" replace />} /> 
// 
//           {/* Root Route Logic (/) - FIX: Direct melucra.com to the landing page */}
//           <Route path="/" element={
//             isMelucraDomain 
//               ? <Navigate to="/mellanding" replace /> // Prod Root -> Landing Page
//               : <Navigate to="/mellanding" replace /> // Dev Root -> Landing Page
//           } />
// 
//           {/* Final Fallback */}
//           <Route path="*" element={<Navigate to="/mellanding" replace />} />
//         </Routes>
//       </div>
//     </ThemeProvider>
//   );
// }
// // 🌟 END MELUCRA MODE RENDERING BLOCK 🌟
// 
// // 🔹 Only run auth loading check if NOT Melucra (ORIGINAL BLOCK REMAINS BELOW)
// if (loading && !isInviteRoute) {
//   return (
//     <ThemeProvider theme={getTheme(themeMode, compactMode)}>
//       <CssBaseline />
//       <div style={{ textAlign: 'center', paddingTop: '20%' }}>
//         Checking session…
//       </div>
//     </ThemeProvider>
//   );
// }
// 
//     const dynamicTheme = getTheme(themeMode, shouldUsePublicShell ? false : compactMode);
// 
//     return (
//         <ThemeProvider theme={dynamicTheme}>
//             <CssBaseline />
//             <GlobalStyles styles={{ body: { backgroundColor: 'transparent' } }} />
//             <AuthProvider user={currentUser} setUser={setCurrentUser}>
//                 <DndContext onDragEnd={handleDragEnd}>
//                     <ProjectProvider>
//                         <div className="App">
//                             <ToastContainer position="top-right" autoClose={3000} />
//                             <NavBar
//                                 onSignOut={handleSignOut}
//                                 onLogin={() => navigate('/login')}
//                                 onSignUp={() => navigate('/signup')}
//                                 isAuthenticated={isAuthenticated}
//                                 currentUser={currentUser}
//                                 onStatusFilter={() => { }}
//                                 onSort={() => { }}
//                                 onSearch={() => { }}
//                             />
// 
//                             {/* ADDED: Dialog for Hierarchy Form */}
//                             <Dialog open={isHierarchyFormModalOpen} onClose={() => navigate(location.state?.from || '/dashboard')}>
//                                 <HierarchyForm onClose={() => navigate(location.state?.from || '/dashboard')} />
//                             </Dialog>
// 
// 
//                             <CookieConsentManager />
//                             <Routes>
//                                 <Route path="/cookie-policy" element={<CookiePolicy />} />
//                                 <Route path="/confirm-email/:token" element={<ConfirmEmail />} />
//                                 <Route path="/confirm-email" element={<ConfirmEmail />} />
// 
//                                 {/* accept legacy /auth links and redirect to the React page */}
//                                 <Route path="/auth/confirm-email/:token" element={<Navigate to="/confirm-email/:token" replace />} />
//                                 <Route path="/auth/confirm-email" element={<Navigate to="/confirm-email" replace />} />
// 
//                                 <Route path="/privacy" element={<PrivacyPage />} />
// 
//                                 <Route
//                                     path="/select-plan"
//                                     element={
//                                         <SelectPlan
//                                             currentUser={isAuthenticated ? currentUser : null}
//                                             currentPlan={
//                                                 isAuthenticated
//                                                     ? (currentUser?.organization?.plan || 'free').toLowerCase()
//                                                     : null
//                                             }
//                                         />
//                                     }
//                                 />
//                                 <Route
//                                     path="/admin"
//                                     element={
//                                         <AdminRoute
//                                             loading={loading}
//                                             isAuthenticated={isAuthenticated}
//                                             currentUser={currentUser}
//                                         >
//                                             <AdminDashboard />
//                                         </AdminRoute>
//                                     }
//                                 />
// 
//                                 {/* Marketing Pages */}
//                                 <Route path="/product/overview" element={<ProductOverviewPage />} />
//                                 <Route path="/product/how-it-works" element={<ProductHowItWorksPage />} />
//                                 <Route path="/product/features" element={<ProductFeaturesPage />} />
//                                 <Route path="/product/security" element={<SecurityPage />} />
// 
//                                 <Route path="/solutions/delivery-team" element={<SolutionsDeliveryPage />} />
//                                 <Route path="/solutions/finance-team" element={<SolutionsFinancePage />} />
//                                 <Route path="/solutions/ops-team" element={<SolutionsOperationsPage />} />
// 
// 
//                                 <Route path="/resources/demo" element={<DemoPage />} />
//                                 <Route path="/resources/problem-outcomes" element={<ProblemOutcomesPage />} />
//                                 <Route path="/resources/advisors" element={<AdvisorsPage />} />
//                                 <Route path="/resources/newsletter" element={<NewsletterSection />} />
//                                 <Route path="/integrations" element={<Navigate to="/product/how-it-works" replace />} />
// 
//                                 <Route path="/" element={<HomePage isAuthenticated={isAuthenticated} />} />
// 
//                                 <Route path="/log-time" element={<ProtectedRoute isAuthenticated={isAuthenticated}><LogTimePage /></ProtectedRoute>} />
// 
//                                 <Route path="/use-cases/:slug" element={<UseCasePage />} />
// 
// 
//                                 <Route path="/admin/advisory-interests" element={<AdvisoryAdminPage />} />
//                                 <Route path="/about" element={<AboutUs />} />
//                                 <Route path="/advisory" element={<AdvisoryForm />} />
//                                 <Route path="/login" element={<LoginForm onLoginSuccess={handleLoginSuccess} />} />
//                                 <Route path="/signup" element={<SignUpForm onSignUpSuccess={handleSignUpSuccess} />} />
//                                 <Route path="/verify-account" element={<ProtectedRoute isAuthenticated={isAuthenticated}><AccountVerification /></ProtectedRoute>} />
//                                 {/* Remove this route: <Route path="/account/recovery/:token" element={<PasswordReset />} /> */}
//                                 <Route path="/projects" element={<ProtectedRoute isAuthenticated={isAuthenticated}><ProjectsContainer /></ProtectedRoute>} />
//                                 <Route path="/expenses" element={<ProtectedRoute isAuthenticated={isAuthenticated}><ExpensesContainer /></ProtectedRoute>} />
// 
//                                 {/* ADDED HIERARCHY OVERVIEW ROUTES */}
//                                 <Route path="/programs" element={<ProtectedRoute isAuthenticated={isAuthenticated}><ProgramOverview /></ProtectedRoute>} />
//                                 <Route path="/portfolios" element={<ProtectedRoute isAuthenticated={isAuthenticated}><PortfolioOverview /></ProtectedRoute>} />
// 
//                                 <Route path="/projects/new" element={<ProtectedRoute isAuthenticated={isAuthenticated}><ProjectForm /></ProtectedRoute>} />
//                                 <Route path="/expenses/new" element={<ProtectedRoute isAuthenticated={isAuthenticated}><ExpenseForm /></ProtectedRoute>} />
//                                 {/* <Route path="/hierarchy/new" element={null} /> */}
// 
//                                 <Route
//                                     path="/hierarchy/new"
//                                     element={
//                                         <ProtectedRoute isAuthenticated={isAuthenticated}>
//                                             <Dialog open onClose={() => navigate(location.state?.from || '/dashboard')}>
//                                                 <HierarchyForm onClose={() => navigate(location.state?.from || '/dashboard')} />
//                                             </Dialog>
//                                         </ProtectedRoute>
//                                     }
//                                 />
//                                 <Route path="/admin/invite" element={
//                                     <ProtectedRoute isAuthenticated={isAuthenticated}>
//                                         <InviteForm />
//                                     </ProtectedRoute>
//                                 } />
//                                 {/* <Route path="/accept-invite/:token" element={<RedirectToSignup />} /> */}
//                                 <Route path="/accept-invite/:token" element={<SignUpForm onSignUpSuccess={handleSignUpSuccess} />} />
// 
// {/* Melucra Landing Page
// <Route path="/melucra" element={<MelucraLanding />} />
// <Route path="/melucra/investor-brief" element={<MelucraInvestorBrief />} /> */}
// 
// 
//                                 <Route
//                                     path="/onboarding"
//                                     element={
//                                         <ProtectedRoute isAuthenticated={isAuthenticated}>
//                                             <OnboardingWizard currentUser={currentUser} />
//                                         </ProtectedRoute>
//                                     }
//                                 />
// 
//                                 <Route path="/dashboard" element={<ProtectedRoute isAuthenticated={isAuthenticated}><Dashboard /></ProtectedRoute>} />
//                                 <Route
//                                     path="/projects/:id"
//                                     element={
//                                         <ProtectedRoute isAuthenticated={isAuthenticated}>
//                                             <ProjectsContainer />
//                                         </ProtectedRoute>
//                                     }
//                                 />
// 
//                                 <Route path="/account" element={<ProtectedRoute isAuthenticated={isAuthenticated}><AccountManagement userId={currentUser?.id} onAccountUpdate={() => showToast('Account updated successfully!')} /></ProtectedRoute>} />
//                                 <Route path="/account/recovery" element={<AccountRecovery />} />
//                                 <Route path="/request-password-reset" element={<AccountRecovery />} />
//                                 <Route path="/reset-password" element={<AccountRecovery />} />
// 
// 
// 
// 
//                                 <Route path="*" element={<h2>Page Not Found</h2>} />
// 
//                                 <Route
//                                     path="/team-management"
//                                     element={
//                                         canManageTeam ? (
//                                             <>
//                                                 {/* <VoiceCommand /> */}
//                                                 <TeamManagement currentUser={currentUser} />
//                                             </>
//                                         ) : (
//                                             <Navigate to="/dashboard" replace />
//                                         )
//                                     }
//                                 />
//                                 <Route path="/pitch" element={<Navigate to="/product/overview" replace />} />
//                                 {/* Route for the Sales Brief microsite */}
//                                 <Route path="/salesbrief" element={<Navigate to="/product/overview" replace />} />
//                                 {/* <Route path="/waitlist" element={<WaitlistLandingPage />} /> */}
//                                 <Route path="/join" element={<Navigate to="/signup" replace />} />
// 
//                                 <Route
//                                     path="/contacts"
//                                     element={
//                                         <AdminRoute
//                                             loading={loading}
//                                             isAuthenticated={isAuthenticated}
//                                             currentUser={currentUser}
//                                         >
//                                             <ContactsPage />
//                                         </AdminRoute>
//                                     }
//                                 />
//                             </Routes>
//                             {/* {isAuthenticated && <FeedbackPrompt />} */}
//                             {isAuthenticated && <FeedbackPrompt />}
//                         </div>
//                     </ProjectProvider>
//                 </DndContext>
//             </AuthProvider>
//         </ThemeProvider>
//     );
// };
// 
// export default App;

import MarketingMetadata from './Components/Layout/Marketing/MarketingMetadata.jsx';
// Modernized and corrected version of
// App.jsx

// ====================================================================================
// 
// IMPORTS
// 
// ====================================================================================

// // React & Core Libraries
// import React, { useEffect, useState, useContext, useMemo } from 'react';
// import { Route, Routes, useNavigate, useLocation, Navigate } from 'react-router-dom';
// 
// // Third-Party Libraries
// import { DndContext } from '@dnd-kit/core';
// import Cookies from 'js-cookie';
// import posthog from 'posthog-js';
// import Lenis from 'lenis';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// 
// // Material-UI
// import { CssBaseline, ThemeProvider, Dialog, GlobalStyles } from '@mui/material';
// 
// // Contexts
// import { SettingsContext } from './context/SettingsContext';
// import { AuthProvider } from './Auth/AuthContext';
// import { ProjectProvider, useProjects } from './ProjectContext.jsx';
// 
// // Layout Components
// import NavBar from './Components/Layout/NavBar.jsx';
// import Footer from './Components/Layout/FooterPro.jsx';
// import ProtectedRoute from './Components/Layout/ProtectedRoute.jsx';
// import AdminRoute from './Components/Layout/AdminRoute';
// import ProtectedAdminRoute from './Components/Layout/ProtectedAdminRoute';
// import InternalRoute from './Components/Layout/InternalRoute';
// 
// 
// // Marketing Page Components
// import {
//     AdvisorsPage, DemoPage, NewsletterSection, ProblemOutcomesPage,
//     ProductFeaturesPage, ProductHowItWorksPage, ProductOverviewPage, SecurityPage,
//     SolutionsDeliveryPage, SolutionsFinancePage, SolutionsOperationsPage, IntegrationsPage,
// } from './Components/Layout/Marketing';
// 
// // Core Application Pages & Components
// import HomePage from './Components/Layout/HomePage.jsx';
// import AboutUs from './Components/Layout/AboutUs.jsx';
// import Dashboard from './Pages/Dashboard.jsx';
// import TeamDashboard from './Pages/TeamDashboard.jsx';
// import OnboardingWizard from './Pages/OnboardingWizard';
// import ProjectsContainer from './Components/Projects/ProjectsContainer.jsx';
// import ExpensesContainer from './Components/Expenses/ExpensesContainer.jsx';
// import ProgramOverview from './Pages/ProgramOverview.jsx';
// import PortfolioOverview from './Pages/PortfolioOverview.jsx';
// import LogTimePage from './Pages/LogTimePage';
// import TeamManagement from './Pages/TeamManagement';
// import ContactsPage from './Pages/ContactsPage';
// import SelectPlan from './Pages/SelectPlan.jsx';
// import UseCasePage from 'Pages/use-cases/UseCasePage';
// import PageLayout from './Components/Layout/PageLayout';
// 
// // User Management Pages & Forms
// import SignUpForm from './Components/UserManagement/UserSignUpForm.jsx';
// import LoginForm from './Components/UserManagement/LoginForm.jsx';
// import AccountManagement from './Components/UserManagement/AccountManagement.jsx';
// import AccountRecovery from './Components/UserManagement/AccountRecovery.jsx';
// import AccountVerification from './Components/UserManagement/AccountVerification';
// import ConfirmEmail from './Auth/ConfirmEmail';
// import InviteForm from './Components/Admin/InviteForm';
// 
// // Other Forms
// import ProjectForm from './Components/Forms/ProjectForm.jsx';
// import ExpenseForm from './Components/Forms/ExpenseForm.jsx';
// import HierarchyForm from './Components/Forms/HierarchyForm.jsx';
// import AdvisoryForm from './Pages/AdvisoryForm';
// 
// // Admin Pages
// import AdminDashboard from './Components/AdminDashboard.jsx';
// import AdvisoryAdminPage from './Pages/AdvisoryAdminPage';
// 
// // Microsites & Landing Pages
// import PitchPage from './MicroSite/PitchPage';
// import SalesBrief from './MicroSite/SalesBrief';
// import WaitlistLandingPage from './Pages/WaitlistLandingPage';
// 
// // Legal & Cookie Pages
// import CookieConsentManager from './Components/CookieConsentManager';
// import CookiePolicy from './Pages/CookiePolicy';
// import PrivacyPage from './Pages/PrivacyPage';
// 
// // Utility Components
// import FeedbackPrompt from './Components/FeedbackPrompt';
// import VoiceCommand from './Components/FinnixAI/VoiceCommand';
// 
// // Helpers & Utilities
// import { getTheme } from './theme';
// import { resolvePlan, hasFeature } from './utils/planUtils';
// import { useTrackUser } from './utils/useTrackUser';
// import { startSessionTimer, stopSessionTimer } from './utils/analyticsTimers';
// 
// // ------------------------------------------------------------------------------------
// // Melucra Specific Imports
// // ------------------------------------------------------------------------------------
// import MelucraLanding from './Melucra/components/MelucraLanding';
// import MelucraInvestorBrief from './Melucra/pages/MelucraInvestorBrief';
// import MelucraDashboardPage from './Melucra/pages/MelucraDashboardPage';
// // ------------------------------------------------------------------------------------
// 
// 
// // ====================================================================================
// // 
// // HELPER FUNCTIONS
// // 
// // ====================================================================================
// 
// export const getCookie = (name) => {
//     const value = `; ${document.cookie}`;
//     const parts = value.split(`; ${name}=`);
//     if (parts.length === 2) return parts.pop().split(';').shift();
// };
// 
// 
// // ====================================================================================
// // 
// // APP COMPONENT
// // 
// // ====================================================================================
// 
// const App = () => {
//     // --------------------------------------------------------------------------------
//     // Melucra Application Logic
//     // This section determines if the app should render as Melucra or FinnixPro.
//     // --------------------------------------------------------------------------------
//     const isMelucraDomain = window.location.host.includes("melucra.com");
//     const isMelucra =
//         isMelucraDomain ||
//         window.location.pathname.startsWith("/melbrief") ||
//         window.location.pathname.startsWith("/meldashboard") ||
//         window.location.pathname.startsWith("/melLanding");
//     const shouldRedirectDashboardToProto = isMelucraDomain && (window.location.pathname === '/melLanding');
//     // --------------------------------------------------------------------------------
// 
//     // Core Hooks
//     const { themeMode, compactMode } = useContext(SettingsContext);
//     const navigate = useNavigate();
//     const location = useLocation();
// 
//     // State Management
//     const [loading, setLoading] = useState(true);
//     const [isAuthenticated, setIsAuthenticated] = useState(false);
//     const [currentUser, setCurrentUser] = useState(null);
//     const [isHierarchyFormModalOpen, setIsHierarchyFormModalOpen] = useState(false);
// 
//     // Custom Hooks
//     useTrackUser(currentUser);
// 
//     // Side Effects (useEffect)
//     useEffect(() => { // Initialize analytics session timer
//         startSessionTimer();
//         return () => stopSessionTimer();
//     }, []);
// 
//     useEffect(() => { // Check user authentication status on load
//         const checkAuth = async () => {
//             try {
//                 const response = await fetch('/auth/me', {
//                     credentials: 'include',
//                     cache: 'no-store'
//                 });
//                 if (!response.ok) throw new Error('Not authenticated');
//                 const userData = await response.json();
//                 setCurrentUser(userData);
//                 setIsAuthenticated(true);
//             } catch (err) {
//                 console.error("Auth check failed:", err);
//                 setCurrentUser(null);
//                 setIsAuthenticated(false);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         checkAuth();
//     }, []);
// 
//     useEffect(() => { // Track page views and manage hierarchy modal visibility
//         posthog.capture('$pageview');
//         if (location.pathname === '/hierarchy/new') {
//             setIsHierarchyFormModalOpen(true);
//         } else if (isHierarchyFormModalOpen) {
//             setIsHierarchyFormModalOpen(false);
//         }
//     }, [location.pathname, isHierarchyFormModalOpen]);
// 
//     useEffect(() => { // Redirect users who need onboarding
//         const clientMarkedDone = sessionStorage.getItem('onboarding_complete') === 'true';
//         if (
//             isAuthenticated &&
//             currentUser?.needs_onboarding &&
//             location.pathname !== '/onboarding' &&
//             !clientMarkedDone
//         ) {
//             navigate('/onboarding', { replace: true });
//         }
//     }, [isAuthenticated, currentUser, location.pathname, navigate]);
//     
//     // Event & Action Handlers
//     const showToast = (message, type = 'success') => toast[type](message);
// 
//     const handleSignUpSuccess = (user) => {
//         setIsAuthenticated(true);
//         setCurrentUser(user);
//         toast.success(`Welcome, ${user.name || 'User'}! Let's get you set up.`);
//         navigate('/dashboard');
//     };
// 
//     const handleLoginSuccess = ({ user }) => {
//         setIsAuthenticated(true);
//         setCurrentUser(user);
//         toast.success(`Welcome back, ${user.name || 'User'}!`);
//         navigate('/dashboard');
//     };
// 
//     const handleSignOut = () => {
//         fetch("/logout", {
//             method: "DELETE",
//             headers: { 'X-CSRF-TOKEN': getCookie("csrf_access_token") }
//         })
//         .then((res) => {
//             if (res.ok) {
//                 sessionStorage.removeItem('onboarding_complete');
//                 setCurrentUser(null);
//                 setIsAuthenticated(false);
//                 showToast("You have been signed out successfully.");
//                 navigate("/");
//             } else {
//                 res.json().then((errorData) => {
//                     showToast(errorData.error || "Error signing out", "error");
//                     if (res.status === 401) navigate("/");
//                 });
//             }
//         })
//         .catch(() => {
//             setCurrentUser(null);
//             setIsAuthenticated(false);
//             showToast("You have been signed out due to a network error.", "info");
//             navigate("/");
//         });
//     };
// 
//     const { updateProjectParent } = useProjects();
//     const handleDragEnd = async (event) => {
//         const { active, over } = event;
//         if (!active || !over) return;
// 
//         const draggedProjectId = parseInt(active.id);
//         const droppedZoneId = String(over.id);
// 
//         let newProgramId = null;
//         let newPortfolioId = null;
// 
//         if (droppedZoneId.startsWith('program_')) {
//             newProgramId = parseInt(droppedZoneId.replace('program_', ''));
//         } else if (droppedZoneId.startsWith('portfolio_')) {
//             newPortfolioId = parseInt(droppedZoneId.replace('portfolio_', ''));
//         } else if (droppedZoneId !== 'orphan_zone') {
//             console.warn("Dropped onto an unrecognized zone:", droppedZoneId);
//             return;
//         }
// 
//         try {
//             await updateProjectParent(draggedProjectId, newProgramId, newPortfolioId);
//             showToast("Project reassigned successfully!", "success");
//         } catch (error) {
//             showToast("Failed to reassign project.", "error");
//             console.error("Drag-and-drop reassign error:", error);
//         }
//     };
// 
//     // Memoized Values & Derived State
//     const isInviteRoute = location.pathname.startsWith('/accept-invite/');
//     const plan = useMemo(() => resolvePlan(currentUser), [currentUser]);
//     const isPaidPlan = useMemo(() => hasFeature(currentUser, 'multi_user_dashboards'), [currentUser]);
//     const canManageTeam = isAuthenticated && currentUser && (currentUser.role === 'SUPER_ADMIN' || (currentUser.role === 'ADMIN' && isPaidPlan));
//     const dynamicTheme = getTheme(themeMode, shouldUsePublicShell ? false : compactMode);
// 
//     // ====================================================================================
//     // 
//     // RENDER BLOCKS
//     // 
//     // ====================================================================================
// 
//     // ---- Melucra Application Render ----
//     if (isMelucra) {
//         return (
//             <ThemeProvider theme={getTheme(themeMode, compactMode)}>
//                 <CssBaseline />
//                 <div className="melucra-wrapper">
//                     <Routes>
//                         <Route path="/meldashboard" element={<MelucraDashboardPage />} />
//                         <Route path="/melbrief" element={<MelucraInvestorBrief />} />
//                         <Route path="/mellanding" element={<MelucraLanding />} />
//                         {shouldRedirectDashboardToProto && (
//                             <Route path="/dashboard" element={<MelucraDashboardPage />} />
//                         )}
//                         <Route path="/melucra" element={<Navigate to="/mellanding" replace />} />
//                         <Route path="/" element={
//                             isMelucraDomain
//                                 ? <Navigate to="/mellanding" replace />
//                                 : <Navigate to="/mellanding" replace />
//                         } />
//                         <Route path="*" element={<Navigate to="/mellanding" replace />} />
//                     </Routes>
//                 </div>
//             </ThemeProvider>
//         );
//     }
// 
//     // ---- Auth Loading State Render ----
//     if (loading && !isInviteRoute) {
//         return (
//             <ThemeProvider theme={dynamicTheme}>
//                 <CssBaseline />
//                 <div style={{ textAlign: 'center', paddingTop: '20%' }}>
//                     Checking session…
//                 </div>
//             </ThemeProvider>
//         );
//     }
// 
//     // ---- Main FinnixPro Application Render ----
//     return (
//         <ThemeProvider theme={dynamicTheme}>
//             <CssBaseline />
//             <GlobalStyles styles={{ body: { backgroundColor: 'transparent' } }} />
//             <AuthProvider user={currentUser} setUser={setCurrentUser}>
//                 <DndContext onDragEnd={handleDragEnd}>
//                     <ProjectProvider>
//                         <div className="App">
//                             <ToastContainer position="top-right" autoClose={3000} />
//                             <NavBar
//                                 onSignOut={handleSignOut}
//                                 onLogin={() => navigate('/login')}
//                                 onSignUp={() => navigate('/signup')}
//                                 isAuthenticated={isAuthenticated}
//                                 currentUser={currentUser}
//                                 onStatusFilter={() => { }}
//                                 onSort={() => { }}
//                                 onSearch={() => { }}
//                             />
//                             <Dialog open={isHierarchyFormModalOpen} onClose={() => navigate(location.state?.from || '/dashboard')}>
//                                 <HierarchyForm onClose={() => navigate(location.state?.from || '/dashboard')} />
//                             </Dialog>
//                             <CookieConsentManager />
// 
//                             <Routes>
//                                 {/* --- PUBLIC & MARKETING ROUTES --- */}
//                                 {/* <Route element={<PageLayout />}> */}
//                                 <Route path="/" element={<HomePage isAuthenticated={isAuthenticated} />} />
//                                 <Route path="/about" element={<AboutUs />} />
//                                 <Route path="/join" element={<Navigate to="/signup" replace />} />
//                                 <Route path="/pitch" element={<Navigate to="/product/overview" replace />} />
//                                 <Route path="/salesbrief" element={<Navigate to="/product/overview" replace />} />
//                                 <Route path="/use-cases/:slug" element={<UseCasePage />} />
//                                 
//                                 {/* Product Pages */}
//                                 <Route path="/product/overview" element={<ProductOverviewPage />} />
//                                 <Route path="/product/how-it-works" element={<ProductHowItWorksPage />} />
//                                 <Route path="/product/features" element={<ProductFeaturesPage />} />
//                                 <Route path="/product/security" element={<SecurityPage />} />
//                                 
//                                 {/* Solutions Pages */}
//                                 <Route path="/solutions/delivery-team" element={<SolutionsDeliveryPage />} />
//                                 <Route path="/solutions/finance-team" element={<SolutionsFinancePage />} />
//                                 <Route path="/solutions/ops-team" element={<SolutionsOperationsPage />} />
//                                 
//                                 {/* Resources Pages */}
//                                 <Route path="/resources/demo" element={<DemoPage />} />
//                                 <Route path="/resources/problem-outcomes" element={<Navigate to="/product/overview" replace />} />
//                                 <Route path="/resources/advisors" element={<AdvisorsPage />} />
//                                 <Route path="/resources/newsletter" element={<NewsletterSection />} />
//                                 <Route path="/integrations" element={<Navigate to="/product/how-it-works" replace />} />
//                                 <Route path="/advisory" element={<AdvisoryForm />} />
//                                 {/* </Route> */}
// 
//                                 {/* --- AUTHENTICATION & USER MANAGEMENT ROUTES --- */}
//                                 <Route path="/login" element={<LoginForm onLoginSuccess={handleLoginSuccess} />} />
//                                 <Route path="/signup" element={<SignUpForm onSignUpSuccess={handleSignUpSuccess} />} />
//                                 <Route path="/accept-invite/:token" element={<SignUpForm onSignUpSuccess={handleSignUpSuccess} />} />
//                                 <Route path="/confirm-email/:token" element={<ConfirmEmail />} />
//                                 <Route path="/confirm-email" element={<ConfirmEmail />} />
//                                 <Route path="/auth/confirm-email/:token" element={<Navigate to="/confirm-email/:token" replace />} />
//                                 <Route path="/auth/confirm-email" element={<Navigate to="/confirm-email" replace />} />
//                                 <Route path="/account/recovery" element={<AccountRecovery />} />
//                                 <Route path="/request-password-reset" element={<AccountRecovery />} />
//                                 <Route path="/reset-password" element={<AccountRecovery />} />
//                                 
//                                 {/* --- PROTECTED APPLICATION ROUTES --- */}
//                                 <Route path="/dashboard" element={<ProtectedRoute isAuthenticated={isAuthenticated}><Dashboard /></ProtectedRoute>} />
//                                 <Route path="/onboarding" element={<ProtectedRoute isAuthenticated={isAuthenticated}><OnboardingWizard currentUser={currentUser} /></ProtectedRoute>} />
//                                 <Route path="/account" element={<ProtectedRoute isAuthenticated={isAuthenticated}><AccountManagement userId={currentUser?.id} onAccountUpdate={() => showToast('Account updated successfully!')} /></ProtectedRoute>} />
//                                 <Route path="/verify-account" element={<ProtectedRoute isAuthenticated={isAuthenticated}><AccountVerification /></ProtectedRoute>} />
//                                 <Route path="/log-time" element={<ProtectedRoute isAuthenticated={isAuthenticated}><LogTimePage /></ProtectedRoute>} />
//                                 
//                                 {/* Project & Expense Management */}
//                                 <Route path="/projects" element={<ProtectedRoute isAuthenticated={isAuthenticated}><ProjectsContainer /></ProtectedRoute>} />
//                                 <Route path="/projects/:id" element={<ProtectedRoute isAuthenticated={isAuthenticated}><ProjectsContainer /></ProtectedRoute>} />
//                                 <Route path="/projects/new" element={<ProtectedRoute isAuthenticated={isAuthenticated}><ProjectForm /></ProtectedRoute>} />
//                                 <Route path="/expenses" element={<ProtectedRoute isAuthenticated={isAuthenticated}><ExpensesContainer /></ProtectedRoute>} />
//                                 <Route path="/expenses/new" element={<ProtectedRoute isAuthenticated={isAuthenticated}><ExpenseForm /></ProtectedRoute>} />
// 
//                                 {/* Hierarchy Management */}
//                                 <Route path="/programs" element={<ProtectedRoute isAuthenticated={isAuthenticated}><ProgramOverview /></ProtectedRoute>} />
//                                 <Route path="/portfolios" element={<ProtectedRoute isAuthenticated={isAuthenticated}><PortfolioOverview /></ProtectedRoute>} />
//                                 <Route path="/hierarchy/new" element={<ProtectedRoute isAuthenticated={isAuthenticated}><Dialog open onClose={() => navigate(location.state?.from || '/dashboard')}><HierarchyForm onClose={() => navigate(location.state?.from || '/dashboard')} /></Dialog></ProtectedRoute>} />
//                                 
//                                 {/* Team Management (Conditional) */}
//                                 <Route path="/team-management" element={canManageTeam ? <TeamManagement currentUser={currentUser} /> : <Navigate to="/dashboard" replace />} />
//                                 
//                                 {/* --- ADMIN ROUTES --- */}
//                                 <Route path="/admin" element={<AdminRoute loading={loading} isAuthenticated={isAuthenticated} currentUser={currentUser}><AdminDashboard /></AdminRoute>} />
//                                 <Route path="/admin/advisory-interests" element={<AdvisoryAdminPage />} />
//                                 <Route path="/admin/invite" element={<ProtectedRoute isAuthenticated={isAuthenticated}><InviteForm /></ProtectedRoute>} />
//                                 <Route path="/contacts" element={<AdminRoute loading={loading} isAuthenticated={isAuthenticated} currentUser={currentUser}><ContactsPage /></AdminRoute>} />
//                                 
//                                 {/* --- LEGAL & POLICY ROUTES --- */}
//                                 <Route path="/cookie-policy" element={<CookiePolicy />} />
//                                 <Route path="/privacy" element={<PrivacyPage />} />
//                                 <Route path="/select-plan" element={<SelectPlan currentUser={isAuthenticated ? currentUser : null} currentPlan={isAuthenticated ? (currentUser?.organization?.plan || 'free').toLowerCase() : null} />} />
// 
//                                 {/* --- FALLBACK ROUTE --- */}
//                                 <Route path="*" element={<h2>Page Not Found</h2>} />
//                             </Routes>
// 
//                             {isAuthenticated && <FeedbackPrompt />}
//                         </div>
//                     </ProjectProvider>
//                 </DndContext>
//             </AuthProvider>
//         </ThemeProvider>
//     );
// };
// 
// export default App;
// 
// 


// Modernized and corrected version with OmecaConnect components
// App.jsx

// ====================================================================================
// 
// IMPORTS
// 
// ====================================================================================

// React & Core Libraries
import React, { Suspense, lazy, useEffect, useState, useContext, useRef } from 'react';
import { Route, Routes, useNavigate, useLocation, Navigate } from 'react-router-dom';

// Third-Party Libraries
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Material-UI
import { CssBaseline, ThemeProvider, GlobalStyles } from '@mui/material';

// Contexts
import { SettingsContext } from './context/SettingsContext';
import { refreshBilling } from './utils/billing';
import { AuthProvider } from './Auth/AuthContext';

// Layout Components
import MarketingNav from './Components/Layout/MarketingNav.jsx';

// Helpers & Utilities
import { getTheme } from './theme';
import { resolvePlan } from './utils/planUtils';
import { useTrackUser } from './utils/useTrackUser';
import { startSessionTimer, stopSessionTimer } from './utils/analyticsTimers';
import {
    clearTikTokCheckout,
    getTikTokCheckout,
    hasTrackedTikTokPurchase,
    markTikTokPurchaseTracked,
    scheduleMarketingTrackers,
    trackTikTokEvent,
    trackTikTokPageView,
} from './utils/marketingTrackers';
import { hasPublicCsvDemoPendingReview } from './utils/publicCsvDemoState';

// ------------------------------------------------------------------------------------
// Microsite Specific Imports
// ------------------------------------------------------------------------------------
const HomePage = lazy(() => import('./Components/Layout/HomePage.jsx'));
const AboutUs = lazy(() => import('./Components/Layout/AboutUs.jsx'));
const SelectPlan = lazy(() => import('./Pages/SelectPlan.jsx'));
const UseCasePage = lazy(() => import('Pages/use-cases/UseCasePage'));

const ProductOverviewPage = lazy(() => import('./Components/Layout/Marketing/ProductOverviewPage'));
const ProductHowItWorksPage = lazy(() => import('./Components/Layout/Marketing/ProductHowItWorksPage'));
const ProductFeaturesPage = lazy(() => import('./Components/Layout/Marketing/ProductFeaturesPage'));
const SecurityPage = lazy(() => import('./Components/Layout/Marketing/SecurityPage'));
const SolutionsDeliveryPage = lazy(() => import('./Components/Layout/Marketing/SolutionsDeliveryPage'));
const SolutionsFinancePage = lazy(() => import('./Components/Layout/Marketing/SolutionsFinancePage'));
const SolutionsOperationsPage = lazy(() => import('./Components/Layout/Marketing/SolutionsOperationsPage'));
const DemoPage = lazy(() => import('./Components/Layout/Marketing/DemoPage'));
const AdvisorsPage = lazy(() => import('./Components/Layout/Marketing/AdvisorsPage'));
const NewsletterSection = lazy(() => import('./Components/Layout/Marketing/NewsletterSection'));
const IntegrationsPage = lazy(() => import('./Components/Layout/Marketing/IntegrationsMarketingPage'));

const SignUpForm = lazy(() => import('./Components/UserManagement/UserSignUpForm.jsx'));
const LoginForm = lazy(() => import('./Components/UserManagement/LoginForm.jsx'));
const AccountRecovery = lazy(() => import('./Components/UserManagement/AccountRecovery.jsx'));
const ConfirmEmail = lazy(() => import('./Auth/ConfirmEmail'));
const OAuthSuccess = lazy(() => import('./Auth/OAuthSuccess'));

const AdvisoryForm = lazy(() => import('./Pages/AdvisoryForm'));

const PitchPage = lazy(() => import('./MicroSite/PitchPage'));
const SalesBrief = lazy(() => import('./MicroSite/SalesBrief'));
const WaitlistLandingPage = lazy(() => import('./Pages/WaitlistLandingPage'));
const CookiePolicy = lazy(() => import('./Pages/CookiePolicy'));
const PrivacyPage = lazy(() => import('./Pages/PrivacyPage'));
const TermsPage = lazy(() => import('./Pages/TermsPage'));
const NotFoundPage = lazy(() => import('./Pages/NotFoundPage'));

const CookieConsentManager = lazy(() => import('./Components/CookieConsentManager'));
const AuthenticatedAppShell = lazy(() => import('./AuthenticatedAppShell'));
// ====================================================================================
// 
// HELPER FUNCTIONS
// 
// ====================================================================================

export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
};

const hasReadableSessionCookie = () => {
    if (typeof document === 'undefined') return false;
    return document.cookie
        .split(';')
        .some((cookie) => cookie.trim().startsWith('csrf_access_token='));
};

const RouteFallback = () => (
    <div style={{ minHeight: '40vh', display: 'grid', placeItems: 'center' }}>
        Loading…
    </div>
);

const MarketingFooter = lazy(() => import('./Components/Layout/FooterPro'));

const publicExactRoutes = new Set([
    '/',
    '/about',
    '/pricing', '/features', '/about-us', '/privacy-policy', '/terms-of-service',
    '/join',
    '/pitch',
    '/salesbrief',
    '/connect', '/core', '/connect/brief', '/contactus', '/mellanding', '/melLanding', '/melbrief', '/meldashboard', '/melucra',
    '/integrations',
    '/advisory',
    '/cookie-policy',
    '/privacy',
    '/terms',
    '/select-plan',
]);

const authExactRoutes = new Set([
    '/login',
    '/signup',
    '/confirm-email',
    '/auth/confirm-email',
    '/oauth-success',
    '/account/recovery',
    '/request-password-reset',
    '/reset-password',
]);

const isPublicMarketingPath = (pathname) =>
    publicExactRoutes.has(pathname) ||
    pathname.startsWith('/use-cases/') ||
    pathname.startsWith('/product/') ||
    pathname.startsWith('/solutions/') ||
    pathname.startsWith('/resources/');

const isAuthPath = (pathname) =>
    authExactRoutes.has(pathname) ||
    pathname.startsWith('/accept-invite/') ||
    pathname.startsWith('/confirm-email/') ||
    pathname.startsWith('/auth/confirm-email/');


// ====================================================================================
// 
// APP COMPONENT
// 
// ====================================================================================

const App = () => {
    // --------------------------------------------------------------------------------
    // Microsite Application Logic
    // This section determines which brand/application to render.
    // --------------------------------------------------------------------------------

    // CORRECTED Omeca Logic (Primary Brand)
    const isOmecaDomain = window.location.host.includes("omeca.com");
    const omecaPaths = [
        '/connect', '/core', '/features', '/about-us', '/pricing',
        '/contactus', 
        '/privacy-policy', '/terms-of-service'
    ];
    const isOmecaPath = omecaPaths.some(path => window.location.pathname.startsWith(path));

    const isOmeca = isOmecaDomain;

    // Melucra Logic (Secondary Microsite)
    const isMelucraDomain = window.location.host.includes("melucra.com");
    const isMelucra = isMelucraDomain;
    const shouldRedirectDashboardToProto = isMelucraDomain && (window.location.pathname === '/melLanding');

    // --------------------------------------------------------------------------------

    // Core Hooks
    const { themeMode, compactMode } = useContext(SettingsContext);
    const navigate = useNavigate();
    const location = useLocation();
    const isInviteRoute = location.pathname.startsWith('/accept-invite/');
    const isPublicMarketingRoute = isPublicMarketingPath(location.pathname);
    const isAuthRoute = isAuthPath(location.pathname);
    const shouldUsePublicShell = !isOmeca && !isMelucra && (isPublicMarketingRoute || isAuthRoute);

    // State Management
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    useEffect(() => {
        const endSession = () => { setCurrentUser(null); setIsAuthenticated(false); };
        window.addEventListener('session-ended', endSession);
        return () => window.removeEventListener('session-ended', endSession);
    }, []);

    const hasCheckedAuthRef = useRef(false);

    // Custom Hooks
    useTrackUser(currentUser);

    // Side Effects (useEffect)
    useEffect(() => { // Initialize analytics session timer
        if (shouldUsePublicShell && !hasReadableSessionCookie()) {
            return undefined;
        }
        startSessionTimer();
        return () => stopSessionTimer();
    }, [shouldUsePublicShell]);

    useEffect(() => { // Check user authentication status on load
        if (shouldUsePublicShell && !hasReadableSessionCookie()) {
            setCurrentUser(null);
            setIsAuthenticated(false);
            setLoading(false);
            return;
        }
        if (hasCheckedAuthRef.current) {
            return;
        }
        hasCheckedAuthRef.current = true;

        const checkAuth = async () => {
            try {
                const { data: userData } = await apiClient.get('/auth/me');
                setCurrentUser(userData);
                setIsAuthenticated(true);
            } catch (err) {
                if (err.message !== 'Not authenticated') {
                    console.error("Auth check failed:", err);
                }
                setCurrentUser(null);
                setIsAuthenticated(false);
            } finally {
                setLoading(false);
            }
        };
        checkAuth();
    }, [shouldUsePublicShell]);

    useEffect(() => { // Track page views and manage hierarchy modal visibility
        let cancelled = false;
        let timeoutId;
        let idleId;
        const pagePath = `${location.pathname}${location.search}`;

        const trackPage = () => {
            if (cancelled) return;
            try {
                const saved = localStorage.getItem('cookie_consent');
                const analyticsEnabled = saved ? Boolean(JSON.parse(saved).analytics) : false;
                if (analyticsEnabled) {
                    import('./utils/analytics').then(({ trackEvent }) => {
                        if (!cancelled) trackEvent('$pageview');
                    });
                }
            } catch (_error) {
                // Stay opted out if consent cannot be read.
            }
            trackTikTokPageView(pagePath);
        };

        if ('requestIdleCallback' in window) {
            idleId = window.requestIdleCallback(trackPage, { timeout: 3000 });
        } else {
            timeoutId = window.setTimeout(trackPage, 1500);
        }

        return () => {
            cancelled = true;
            if (idleId) window.cancelIdleCallback?.(idleId);
            if (timeoutId) window.clearTimeout(timeoutId);
        };
    }, [location.pathname, location.search]);

    const isolateMarketingScripts = window.__finnixMarketingTrackersLoaded && !isMarketingPage(location.pathname);
    useEffect(() => {
        if (isolateMarketingScripts) {
            // A full navigation unloads third-party scripts before sensitive UI renders.
            window.location.replace(`${location.pathname}${location.search}${location.hash}`);
        } else {
            scheduleMarketingTrackers();
        }
    }, [isolateMarketingScripts, location.pathname, location.search, location.hash]);

    const onboardingSessionKey = currentUser?.id ? `onboarding_complete:${currentUser.id}` : null;

    // First financial value lives on the dashboard. Optional workspace setup
    // remains available at /onboarding?setup=workspace without forcing a detour.

    useEffect(() => {
        const updateBilling = event => { if (event.detail?.user) setCurrentUser(event.detail.user); };
        window.addEventListener('billing-updated', updateBilling);
        return () => window.removeEventListener('billing-updated', updateBilling);
    }, []);

    const billingAdmin = Boolean(currentUser?.is_workspace_admin && currentUser?.billing?.has_billing_customer);
    useEffect(() => {
        if (!isAuthenticated || !billingAdmin) return undefined;
        let lastAttempt = 0;
        const reconcile = () => {
            if (document.visibilityState === 'hidden' || Date.now() - lastAttempt < 15 * 60 * 1000) return;
            const params = new URLSearchParams(window.location.search);
            // The account panel owns explicit/portal refreshes. Avoid duplicate
            // requests when its return handler removes the query string.
            if (window.location.pathname === '/account' || params.has('session_id') || params.has('billing_return')) return;
            lastAttempt = Date.now();
            refreshBilling().catch(() => toast.warn('Billing status could not be refreshed. Check Account & Billing for the last confirmed details.'));
        };
        reconcile();
        const timer = window.setInterval(reconcile, 15 * 60 * 1000);
        window.addEventListener('focus', reconcile);
        return () => { window.clearInterval(timer); window.removeEventListener('focus', reconcile); };
    }, [isAuthenticated, currentUser?.id, billingAdmin]);

    useEffect(() => {
        const sessionId = new URLSearchParams(location.search).get('session_id');
        if (!isAuthenticated || !sessionId) return undefined;
        let cancelled = false;
        const reconcileCheckout = async () => {
            try {
                const { data } = await apiClient.get(`/api/checkout-session-status?session_id=${encodeURIComponent(sessionId)}`);
                if (cancelled) return;
                if (data.user) setCurrentUser(data.user);
                if (data.status === 'complete' && ['paid', 'no_payment_required'].includes(data.payment_status)) {
                    if (!hasTrackedTikTokPurchase(sessionId)) {
                        const checkout = getTikTokCheckout();
                        if (checkout) {
                            trackTikTokEvent('Purchase', { ...checkout, plan_id: checkout.plan_id || data.plan });
                            markTikTokPurchaseTracked(sessionId); clearTikTokCheckout();
                        }
                    }
                    toast.success('Checkout confirmed. Your plan has been refreshed.');
                } else {
                    toast.info('Payment is not yet confirmed. You can refresh its status in Account & Billing.');
                }
            } catch (err) {
                if (!cancelled) toast.warn(err.response?.data?.error || 'Checkout could not be confirmed yet. Refresh billing status in Account & Billing.');
            } finally {
                if (!cancelled) navigate(location.pathname, { replace: true });
            }
        };
        reconcileCheckout();
        return () => { cancelled = true; };
    }, [isAuthenticated, location.pathname, location.search, navigate]);

    // Event & Action Handlers
    const showToast = (message, type = 'success') => toast[type](message);

    const handleSignUpSuccess = (user) => {
        setIsAuthenticated(true);
        setCurrentUser(user);
        toast.success(`Welcome, ${user.name || 'User'}! Let's get you set up.`);
        navigate(hasPublicCsvDemoPendingReview() ? '/resources/demo' : '/dashboard');
    };

    const handleLoginSuccess = ({ user }) => {
        setIsAuthenticated(true);
        setCurrentUser(user);
        navigate(hasPublicCsvDemoPendingReview() ? '/resources/demo' : '/dashboard');
    };

    const handleSignOut = () => {
        fetch("/logout", {
            method: "DELETE",
            headers: { 'X-CSRF-TOKEN': getCookie("csrf_access_token") }
        })
            .then((res) => {
                if (res.ok) {
                    if (onboardingSessionKey) {
                        sessionStorage.removeItem(onboardingSessionKey);
                    }
                    sessionStorage.removeItem('onboarding_complete');
                    setCurrentUser(null);
                    setIsAuthenticated(false);
                    navigate("/");
                } else {
                    res.json().then((errorData) => {
                        showToast(errorData.error || "Error signing out", "error");
                        if (res.status === 401) navigate("/");
                    });
                }
            })
            .catch(() => {
                setCurrentUser(null);
                setIsAuthenticated(false);
                showToast("You have been signed out due to a network error.", "info");
                navigate("/");
            });
    };

    // Memoized Values & Derived State
    const canManageTeam = isAuthenticated && currentUser && ['ADMIN', 'SUPER_ADMIN'].includes((currentUser.role || '').toUpperCase());
    const dynamicTheme = getTheme(themeMode, shouldUsePublicShell ? false : compactMode);

    // ====================================================================================
    // 
    // RENDER BLOCKS
    // 
    // ====================================================================================

    if (isolateMarketingScripts) return <RouteFallback />;

    // ---- Omeca Application Render (Primary Brand) ----
    // ---- Omeca Application Render (Primary Brand) ----
    if (isOmeca) {
        return (
            <ThemeProvider theme={getTheme(themeMode, compactMode)}>
                <CssBaseline />
                <div className="omeca-wrapper">
                    <LegacyNotice />
                    <Suspense fallback={<RouteFallback />}>
                        <Routes>
                            {/* Main Omeca Pages */}
                            <Route path="/connect" element={null} />
                            <Route path="/core" element={null} />

                            <Route path="/connect/brief" element={null} />

                            {/* CORRECTED: Routes using the new aliased component names */}
                            <Route path="/features" element={null} />
                            <Route path="/pricing" element={null} />
                            <Route path="/about-us" element={null} />

                            {/* Add these as you create the components */}
                            {/* <Route path="/contact" element={<OmecaContactPage />} /> */}

                            {/* Legal pages — redirect to shared FinnixPro policy pages until Omeca-specific ones are built */}
                            <Route path="/privacy" element={<PrivacyPage />} />
                            <Route path="/terms" element={<TermsPage />} />
                            <Route path="/privacy-policy" element={<Navigate to="/privacy" replace />} />
                            <Route path="/terms-of-service" element={<Navigate to="/terms" replace />} />

                            {/* Default root path for the Omeca brand */}
                            <Route path="/" element={
                                isOmecaDomain
                                    ? <Navigate to="/connect" replace />
                                    : <HomePage isAuthenticated={isAuthenticated} />
                            } />

                            {/* Fallback route for any other path on the Omeca domain */}
                            <Route path="*" element={<Navigate to="/connect" replace />} />
                        </Routes>
                    </Suspense>
                </div>
            </ThemeProvider>
        );
    }

    // ---- Melucra Application Render ----
    if (isMelucra) {
        return (
            <ThemeProvider theme={getTheme(themeMode, compactMode)}>
                <CssBaseline />
                <div className="melucra-wrapper">
                    <LegacyNotice />
                    <Suspense fallback={<RouteFallback />}>
                        <Routes>
                            <Route path="/meldashboard" element={null} />
                            <Route path="/melbrief" element={null} />
                            <Route path="/mellanding" element={null} />
                            {shouldRedirectDashboardToProto && (
                                <Route path="/dashboard" element={null} />
                            )}
                            <Route path="/melucra" element={<Navigate to="/mellanding" replace />} />
                            <Route path="/" element={
                                isMelucraDomain
                                    ? <Navigate to="/mellanding" replace />
                                    : <Navigate to="/mellanding" replace />
                            } />
                            <Route path="*" element={<Navigate to="/mellanding" replace />} />
                        </Routes>
                    </Suspense>
                </div>
            </ThemeProvider>
        );
    }

    // ---- Lightweight FinnixPro Public Marketing Render ----
    if (shouldUsePublicShell) {
        return (
            <ThemeProvider theme={dynamicTheme}>
                <CssBaseline />
                <GlobalStyles styles={(theme) => ({
                    html: { backgroundColor: theme.palette.background.default },
                    body: { backgroundColor: theme.palette.background.default },
                    '#root': { backgroundColor: theme.palette.background.default, minHeight: '100vh' },
                })} />
                <div className="App">
                    <MarketingMetadata />
                    <MarketingNav
                        isAuthenticated={isAuthenticated}
                        onLogin={() => navigate('/login')}
                        onSignUp={() => navigate('/signup')}
                    />
                    <Suspense fallback={null}>
                        <CookieConsentManager />
                    </Suspense>
                    <Suspense fallback={<RouteFallback />}>
                        <Routes>
                            {['/connect', '/core', '/connect/brief', '/contactus', '/mellanding', '/melLanding', '/melbrief', '/meldashboard', '/melucra'].map(path => <Route key={path} path={path} element={<Navigate to="/product/overview" replace />} />)}
                            <Route path="/pricing" element={<Navigate to="/select-plan" replace />} />
                            <Route path="/features" element={<Navigate to="/product/features" replace />} />
                            <Route path="/about-us" element={<Navigate to="/about" replace />} />
                            <Route path="/privacy-policy" element={<Navigate to="/privacy" replace />} />
                            <Route path="/terms-of-service" element={<Navigate to="/terms" replace />} />
                            <Route path="/" element={<HomePage isAuthenticated={isAuthenticated} />} />
                            <Route path="/about" element={<AboutUs />} />
                            <Route path="/join" element={<Navigate to="/signup" replace />} />
                            <Route path="/pitch" element={<Navigate to="/product/overview" replace />} />
                            <Route path="/salesbrief" element={<Navigate to="/product/overview" replace />} />
                            <Route path="/use-cases/:slug" element={<UseCasePage />} />

                            <Route path="/product/overview" element={<ProductOverviewPage />} />
                            <Route path="/product/how-it-works" element={<ProductHowItWorksPage />} />
                            <Route path="/product/features" element={<ProductFeaturesPage />} />
                            <Route path="/product/security" element={<SecurityPage />} />

                            <Route path="/solutions/delivery-team" element={<SolutionsDeliveryPage />} />
                            <Route path="/solutions/finance-team" element={<SolutionsFinancePage />} />
                            <Route path="/solutions/ops-team" element={<SolutionsOperationsPage />} />

                            <Route path="/resources/demo" element={<DemoPage isAuthenticated={isAuthenticated} currentUser={currentUser} />} />
                            <Route path="/resources/problem-outcomes" element={<Navigate to="/product/overview" replace />} />
                            <Route path="/resources/advisors" element={<AdvisorsPage />} />
                            <Route path="/resources/newsletter" element={<NewsletterSection />} />
                            <Route path="/integrations" element={<Navigate to="/product/how-it-works" replace />} />
                            <Route path="/advisory" element={<AdvisoryForm />} />

                            <Route
                                path="/login"
                                element={
                                    <AuthProvider user={currentUser} setUser={setCurrentUser}>
                                        <LoginForm onLoginSuccess={handleLoginSuccess} />
                                    </AuthProvider>
                                }
                            />
                            <Route path="/signup" element={<SignUpForm onSignUpSuccess={handleSignUpSuccess} />} />
                            <Route path="/accept-invite/:token" element={<SignUpForm onSignUpSuccess={handleSignUpSuccess} />} />
                            <Route path="/confirm-email/:token" element={<ConfirmEmail />} />
                            <Route path="/confirm-email" element={<ConfirmEmail />} />
                            <Route path="/auth/confirm-email/:token" element={<ConfirmEmail />} />
                            <Route path="/auth/confirm-email" element={<ConfirmEmail />} />
                            <Route
                                path="/oauth-success"
                                element={
                                    <AuthProvider user={currentUser} setUser={setCurrentUser}>
                                        <OAuthSuccess />
                                    </AuthProvider>
                                }
                            />
                            <Route path="/account/recovery" element={<AccountRecovery />} />
                            <Route path="/request-password-reset" element={<AccountRecovery />} />
                            <Route path="/reset-password" element={<AccountRecovery />} />

                            <Route path="/cookie-policy" element={<CookiePolicy />} />
                            <Route path="/privacy" element={<PrivacyPage />} />
                            <Route path="/terms" element={<TermsPage />} />
                            <Route path="/select-plan" element={<SelectPlan currentUser={isAuthenticated ? currentUser : null} currentPlan={isAuthenticated ? resolvePlan(currentUser) : null} />} />

                            <Route path="*" element={<NotFoundPage />} />
                        </Routes>
                    </Suspense>
                    <Suspense fallback={null}><MarketingFooter /></Suspense>
                </div>
            </ThemeProvider>
        );
    }

    // ---- Auth Loading State Render ----
    if (loading && !isInviteRoute) {
        return (
            <ThemeProvider theme={dynamicTheme}>
                <CssBaseline />
                <div style={{ textAlign: 'center', paddingTop: '20%' }}>
                    Checking session…
                </div>
            </ThemeProvider>
        );
    }

    // ---- Main FinnixPro Application Render (Default) ----
    return (
        <ThemeProvider theme={dynamicTheme}>
            <CssBaseline />
            <Suspense fallback={<RouteFallback />}>
                <AuthenticatedAppShell
                    currentUser={currentUser}
                    setCurrentUser={setCurrentUser}
                    isAuthenticated={isAuthenticated}
                    loading={loading}
                    onboardingSessionKey={onboardingSessionKey}
                    canManageTeam={canManageTeam}
                    handleLoginSuccess={handleLoginSuccess}
                    handleSignUpSuccess={handleSignUpSuccess}
                    handleSignOut={handleSignOut}
                    showToast={showToast}
                />
            </Suspense>
        </ThemeProvider>
    );
};

export default App;
